import { GridPercentageCellComponent } from '../../../components/templates/percentage/percentage.component';
import { NumberCol } from '../number/number-col';

export class PercentageCol extends NumberCol {
  public override getColDef() {
    return {
      ...super.getColDef(),
      ...{
        cellRenderer: GridPercentageCellComponent,
        cellStyle: { justifyContent: 'flex-start', textAlign: 'left' },
      },
    };
  }
}
